import React, { memo, useCallback, useState } from 'react';

import { Box, Button } from '@mui/material';
import TextFieldCDS from '@sharedCR/coreDesignSystem/form/TextFieldCDS';
import { AddBoxIcon } from '@sharedCR/coreDesignSystem/icons';
import _ from 'lodash';
import PropTypes from 'prop-types';

import {
  PREVIEW_ADD_CLAUSE_BUTTON_LABEL,
  PREVIEW_ADD_CLAUSE_HIDE_BUTTON_LABEL,
  PREVIEW_ADD_CLAUSE_PLACEHOLDER,
  PREVIEW_ADD_CLAUSE_SUBMIT_BUTTON_LABEL,
} from './GenerateExpression.constants';
import {
  previewAddClauseActionsRowStyles,
  previewAddClauseInputRowStyles,
  previewAddClauseWrapperStyles,
} from './GenerateExpression.styles';
import { GenerateExpressionTestIds } from './GenerateExpression.testIds';

const AddClauseInput = ({ isDisabled, onSubmit }) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const [value, setValue] = useState('');

  const onExpand = useCallback(() => setIsExpanded(true), []);

  const onCancel = useCallback(() => {
    setIsExpanded(false);
    setValue('');
  }, []);

  const onChange = useCallback(event => setValue(event.target.value), []);

  const onSubmitClick = useCallback(() => {
    const trimmed = _.trim(value);

    if (_.isEmpty(trimmed)) {
      return;
    }

    onSubmit(trimmed);
    setIsExpanded(false);
    setValue('');
  }, [onSubmit, value]);

  const isSubmitDisabled = isDisabled || _.isEmpty(_.trim(value));

  return (
    <Box sx={previewAddClauseWrapperStyles}>
      {!isExpanded ? (
        <Button
          data-testid={GenerateExpressionTestIds.MODAL_PREVIEW_ADD_CLAUSE_BUTTON}
          disabled={isDisabled}
          startIcon={<AddBoxIcon />}
          variant="text"
          onClick={onExpand}
        >
          {PREVIEW_ADD_CLAUSE_BUTTON_LABEL}
        </Button>
      ) : (
        <Box sx={previewAddClauseInputRowStyles}>
          <TextFieldCDS
            dataTestId={GenerateExpressionTestIds.MODAL_PREVIEW_ADD_CLAUSE_INPUT}
            name="addClauseInput"
            placeholder={PREVIEW_ADD_CLAUSE_PLACEHOLDER}
            value={value}
            onChange={onChange}
          />
          <Box sx={previewAddClauseActionsRowStyles}>
            <Button
              data-testid={GenerateExpressionTestIds.MODAL_PREVIEW_ADD_CLAUSE_HIDE}
              variant="text"
              onClick={onCancel}
            >
              {PREVIEW_ADD_CLAUSE_HIDE_BUTTON_LABEL}
            </Button>
            <Button
              color="primary"
              data-testid={GenerateExpressionTestIds.MODAL_PREVIEW_ADD_CLAUSE_SUBMIT}
              disabled={isSubmitDisabled}
              variant="contained"
              onClick={onSubmitClick}
            >
              {PREVIEW_ADD_CLAUSE_SUBMIT_BUTTON_LABEL}
            </Button>
          </Box>
        </Box>
      )}
    </Box>
  );
};

AddClauseInput.propTypes = {
  isDisabled: PropTypes.bool.isRequired,
  onSubmit: PropTypes.func.isRequired,
};

export default memo(AddClauseInput);
